module.exports = __webpack_public_path__ + "static/per-erik-e3efde944aead3352f91a32fdd6815b9.png";